import React from 'react';
import { MBView } from '@shared/components/MBView';
import { View } from '@shared/components/View';
import { MBHover } from '@shared/components/hover';
import { MBText } from '@shared/components/text';
import { MBTouchableOpacity } from '@shared/components/touchable';
import { Styles } from './styles';

export interface MBChatInputMentionRowProps {
  title: string;
  description?: string;
  image: React.ReactNode;
  selected?: boolean;
  onPress(): void;
  onHoverStart?(): void;
  onHoverEnd?(): void;
}

/*
    Note: we only show a selected item on web, since selecting
    a highlighted mention item won't work on native (it's
    controlled by pressing enter).
*/
export function MBChatInputMentionRow({
  title,
  description,
  image,
  selected,
  onPress,
  onHoverStart,
  onHoverEnd,
}: MBChatInputMentionRowProps) {
  return (
    <MBHover
      hoverStyle={Styles.mentionRowHover}
      style={selected && Styles.mentionRowHover}
      onHoverStart={onHoverStart}
      onHoverEnd={onHoverEnd}
    >
      <MBTouchableOpacity onPress={onPress}>
        <View row centerVertically paddingHorizontal={1} paddingVertical={1}>
          <MBView style={Styles.mentionRowImage}>{image}</MBView>
          <View paddingLeft={1} />
          <MBText bold>{title}</MBText>
          <View paddingLeft={0.5} />
          {!!description && <MBText>({description})</MBText>}
        </View>
      </MBTouchableOpacity>
    </MBHover>
  );
}
